import { Controller } from "@hotwired/stimulus"

// Comment reply controller
// Handles showing/hiding reply forms for nested comments
export default class extends Controller {
  showReplyForm(event) {
    const commentId = event.currentTarget.dataset.commentId
    const replyForm = document.getElementById(`reply-form-${commentId}`)

    // Hide all other reply forms first
    document.querySelectorAll('[id^="reply-form-"]').forEach(form => {
      if (form.id !== `reply-form-${commentId}`) {
        form.classList.add('hidden')
      }
    })

    if (replyForm) {
      replyForm.classList.remove('hidden')
      // Focus the textarea
      const textarea = replyForm.querySelector('textarea')
      if (textarea) {
        textarea.focus()
      }
    }
  }

  hideReplyForm(event) {
    const commentId = event.currentTarget.dataset.commentId
    const replyForm = document.getElementById(`reply-form-${commentId}`)

    if (replyForm) {
      replyForm.classList.add('hidden')
      // Clear the textarea
      const textarea = replyForm.querySelector('textarea')
      if (textarea) {
        textarea.value = ''
      }
    }
  }

  submitReply(event) {
    // Form will submit normally via Turbo
    // This can be used to add loading states if needed
  }
}
